export const USER_PROFILE_URL = '/users/profile'
